import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "tagsMultiUpdate.title",
    defaultMessage: "Create tags by excel",
  },
  instructions: {
    id: "tagsMultiUpdate.instructions",
    defaultMessage: "Load the file you want to process and click on the Import button",
  },
  btnImportFile: {
    id: "tagsMultiUpdate.btnImportFile",
    defaultMessage: "Import Excel File",
  },
  btnDownloadFile: {
    id: "tagsMultiUpdate.btnDownloadFile",
    defaultMessage: "Download Excel File",
  },
  dropFiles: {
    id: "tagsMultiUpdate.dropFiles",
    defaultMessage: "Drop files here...",
  },
  btnBackToTags: {
    id: "tagsMultiUpdate.btnBackToTags",
    defaultMessage: "Back to tags management",
  },
  saveSuccess: {
    id: "tagsMultiUpdate.saveSuccess",
    defaultMessage: "Update successful",
  },
});
